import { render } from "./DeliveryStartRow.vue?vue&type=template&id=55f5b15a&scoped=true"
import script from "./DeliveryStartRow.vue?vue&type=script&lang=js"
export * from "./DeliveryStartRow.vue?vue&type=script&lang=js"

import "./DeliveryStartRow.vue?vue&type=style&index=0&id=55f5b15a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f5b15a"]])

export default __exports__